<template>
  <div class="coupon-send">
    <common-layout>
      <div slot="header">
        <h3>创新券发放</h3>
      </div>
      <div slot="container">
        <div class="coupon-send.header">
          <section>
            <div class="base-search">
              <!--<el-button
              type="success"
              class="coupon-send.addBtn"
              @click="addEvent"
              >+ 新增</el-button
            >-->
              <el-button type="danger" @click="deleteAll">批量删除</el-button>
              <el-input
                  placeholder="请输入申领单位名称"
                  v-model="listQuery.keyword"
                  class="input-with-select"
                  @keyup.enter.native="search"
                  clearable
                  @clear="search"
                  style="width: 240px"
              >
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
              </el-input>

              <el-select
                  v-model="listQuery.applyStatus"
                  placeholder="请选择审核状态"
                  clearable
                  style="display: block;width: 200px;"
                  @change="searchSelect"
              >
                <el-option v-for="item in applyStatusList" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </div>
          </section>
          <section>
            <!--<el-button type="primary" @click="downFn">下载Excel模板</el-button>
            <el-button type="success" @click="exportFn">导入Excel</el-button>-->
          </section>
        </div>
        <div class="float-index.table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :index="indexFn"
              width="150"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="申领单位名称"
              align="center"
              prop="mainName"
            ></el-table-column>
            <el-table-column
              label="申领主体"
              :formatter="formatter"
              align="center"
              prop="mainType"
            ></el-table-column>
            <el-table-column
              label="服务类型"
              align="center"
              prop="serviceType"
              :formatter="formatter"
            ></el-table-column>
            <!-- <el-table-column
              label="地区"
              :formatter="formatter"
              align="center"
              prop="city"
            >
            </el-table-column> -->
            <el-table-column
              label="创新券总额（元）"
              align="center"
              prop="applyAmount"
            ></el-table-column>
            <el-table-column label="申领日期" align="center">
              <template slot-scope="scope">
                <!--{{ scope.row.assign_date.slice(0, 4) + "年" }}-->
                {{ scope.row.applyTime }}
              </template>
            </el-table-column>
            <el-table-column label="审核状态" align="center" prop="applyStatus" :formatter="formatter">
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  @click="handleDelete(scope.row)"
                  type="danger"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="page_size"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog
      :title="tipTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          label="申领单位名称"
          :label-width="formLabelWidth"
          prop="mainName"
        >
          <el-input
            v-model="form.mainName"
            autocomplete="off"
            placeholder="请输入申领单位名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="申领主体"
          :label-width="formLabelWidth"
          prop="mainType"
        >
          <el-select
            v-model="form.mainType"
            placeholder="请选择申领主体"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in apply_mains"
              :key="index"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="服务类型"
          :label-width="formLabelWidth"
          prop="serviceType"
        >
          <el-select
            v-model="form.serviceType"
            placeholder="请选择服务类型"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in service_types"
              :key="index"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="申领日期"
          :label-width="formLabelWidth"
          prop="applyTime"
        >
          <el-date-picker
            v-model="form.applyTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择申领日期"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="创新券总额"
          :label-width="formLabelWidth"
          prop="applyAmount"
        >
          <el-input
            v-model="form.applyAmount"
            autocomplete="off"
            type="number"
            placeholder="请输入创新券总额"
          ></el-input>
        </el-form-item>
        <el-form-item label="审批状态" :label-width="formLabelWidth" prop="applyStatus">
          <el-select
            v-model="form.applyStatus"
            placeholder="请选择审核状态"
            style="width: 100%"
          >
            <el-option v-for="item in applyStatusList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核意见" :label-width="formLabelWidth" prop="auditOpinion">
          <el-input v-model="form.auditOpinion" placeholder="请填写审核意见"></el-input>
        </el-form-item>
        <el-form-item label="附件上传" :label-width="formLabelWidth">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            style="text-align: left;"
            :before-upload="beforeFileUploadLimit"
            :on-remove="(file, fileList) => handleFileRemove(file, fileList, 'auditFile')"
            :limit="1"
            :file-list="auditFile"
            :on-success="(response, file, fileList) => handleFileSuccess(response, file, fileList, 'auditFile')"
            list-type="picture"
          >
            <el-button
                size="small"
                type="primary"
            >
              上传附件材料
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Row } from "element-ui";
import CommonLayout from "../../components/common-layout.vue";
import { FunDownload, ExportFn, DisabledDateFn,DisabledDateFn1 } from ".././../utils/tool";
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      apply_mains: [
        { id: 1, label: '企业' },
        { id: 2, label: '团队' }
      ],
      tipTitle: "新增",
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      service_types: [
        { id: 1, label: '检验检测' },
        { id: 2, label: '委托开发' },
        { id: 3, label: '专利申请代理' },
        { id: 4, label: '技术转移' }
      ],
      applyStatusList: [
        { id: 1, label: '待审核' },
        { id: 2, label: '不通过' },
        { id: 3, label: '退回' },
        { id: 4, label: '通过' }
      ],
      is_submit: true,
      tableData: [],
      auditFile: [],
      deleteIds: "",
      listQuery: {
        keyword: '',
        applyStatus: '',
        is_page: 0,
        page: 1,
        pageSize: 10
      },
      currentPage: 1,
      total: 0,
      per_page: 10,

      page_size: 10,
      dialogFormVisible: false,
      formLabelWidth: "120px",

      form: {
        mainName: "",
        mainType: '',
        serviceType: "",
        applyTime: "",
        applyAmount: "",
        applyStatus: ""
      },
      rules: {
        mainName: [
          {
            required: true,
            message: "请输入申领单位名称",
            trigger: "blur",
          },
        ],
        mainType: [
          {
            required: true,
            message: "请选择申领主体",
            trigger: "change",
          },
        ],
        serviceType: [
          {
            required: true,
            message: "请选择服务类型",
            trigger: "change",
          },
        ],
        applyTime: [
          {
            required: true,
            message: "请选择申领日期",
            trigger: "change",
          },
        ],
        applyAmount: [
          {
            required: true,
            message: "请输入创新券总额",
            trigger: "blur",
          },
        ],
        applyStatus: [
          {
            required: true,
            message: "请选择审批状态",
            trigger: ['blur', 'change'],
          },
        ],
      },
    };
  },
  created() {
    this.ResetForm({ value: this.form });
    this.getData();
  },
  methods: {
    beforeFileUploadLimit(file) {
      if (this.auditFile.length === 1) {
        return this.$message.warning('您已经上传了一份附件，请删除后重新上传');
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }
      return isLt2M;
    },
    handleFileRemove(file, fileList, type) {
      this.auditFile = fileList;
      this.fileListChange(type);
    },
    handleFileSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this.auditFile = fileList;
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.form[type] = JSON.stringify(arr);

      } else {
        this.form[type] = '';
        this[type] = [];
      }
    },
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    searchSelect(e) {
      if (e) {
        this.listQuery.applyStatus = e;
        this.getData();
      } else {
        this.$delete(this.listQuery, 'applyStatus');
        this.getData();
      }
    },
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn1(time);
    },
    // 导入

    async exportFn() {
      let res = await ExportFn(this.export_url, { type: 1 });
      if (res.code === 0 && res.data.is_export) {
        this.getData({ url: this.current_url });
        this.$message.success(`数据导入成功${res.data.suc_num || 0}条`);
      } else {
        this.$message.warning(`数据导入失败${res.data.fail_num || 0}条`);
      }
    },

    //   下载
    downFn() {
      FunDownload(
        this.imgUrl + "lanzhoufile/创新券发放.xlsx",
        "创新券发放.xlsx"
      );
    },

    // 批量删除
    deleteAll() {
      this.handleDelete(this.deleteIds);
    },

    //   分页改变
    handleCurrentChange(e) {
      this.getData({ url: this.current_url, pam: { page: e } });
    },
    indexFn(index) {
      return (this.currentPage - 1) * this.page_size + index + 1;
    },
    // 列表数据回填
    formatter(row, column, cellValue, index) {
      switch (column.property) {
        case "serviceType": {
          let value = this.service_types.find(item => item.id == cellValue)?.label;
          return value || "";
          break;
        }
        case "mainType": {
          let value = this.apply_mains.find(item => item.id == cellValue)?.label;
          return value || "";

          break;
        }
        case "applyStatus": {
          let value = this.applyStatusList.find(item => item.id == cellValue)?.label;
          return value || "";

          break;
        }

        default: {
          return "";
          break;
        }
      }
    },

    //   新增 & 编辑
    onSubmit() {
      if (!this.is_submit) return false;
      this.is_submit = false;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let obj = JSON.stringify(this.form);
          obj = JSON.parse(obj);
          obj.address = JSON.stringify(obj.address);

          if (obj?.id) {
            this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/innovation/coupon/update`, this.form)
            .then(res => {
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.dialogFormVisible = false;

                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
          } else {
            this.http
              .post(this.current_url, obj)
              .then((res) => {
                if (res.code === 0) {
                  this.dialogFormVisible = false;

                  this.getData({ url: this.current_url });
                  this.$message.success("创新发放券成功");
                }
              })
              .catch((err) => {
                console.error("捕获", err);
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;
        }
      });
    },

    // 获取列表
    async getData() {
      const res = await this.http.post(`${urlConfig.devUrl}apij2/admin-api/innovation/coupon/page`, this.listQuery);
      if (res.code === 0) {
        this.tableData = res.data?.data.map((el) => {
          el.applyAmount = Number(el.applyAmount).toFixed(2);
          return el;
        });
        this.total = res.data?.total;
      }
    },
    // 编辑
    handleEdit(item) {
      this.tipTitle = "编辑";

      // if (item.applyTime.length === 10) {
      //   item.applyTime = item.applyTime + " 00:00:00";
      // }
      this.auditFile = item.auditFile ? JSON.parse(item.auditFile) : [];
      this.form = item;
      this.is_submit = true;
      this.dialogFormVisible = true;
    },
    async handleDelete(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let ids = []
          if (this.deleteIds.length) {
            ids = this.deleteIds
          } else {
            ids = [row.id]
          }
          this.http.delete(`${urlConfig.devUrl}apij2/admin-api/innovation/coupon/delete`, { ids }).then(res => {
            if (res.code === 0) {
              this.getData();
              this.$message({
                type: 'success',
                message: '删除成功',
              });
            } else {
              this.$message({
                message: '失败！',
                type: 'error',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 新增

    addEvent() {
      this.tipTitle = "新增";

      this.form = this.ResetForm({ type: true, name: "form" });

      this.dialogFormVisible = true;

      this.is_submit = true;
    },
    // 城市
    citySelected(e) {
      this.form.address = e;
    },
    // 城市
    selectionChange(selection) {
      this.deleteIds = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteIds = arr;
      }
    },
  },
};
</script>

<style lang="scss">
@include component(coupon-send) {
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: space-between;

    @include component(el-input) {
      width: 300px;
    }
  }

  @include part(searchBtn) {
    margin-left: 10px;
  }

  @include part(addBtn) {
    margin-right: 30px !important;
    background: #623aa2 !important;
    color: #fff;
    border: none;
  }

  @include part(table) {
    margin-top: 30px;
  }
  .distpicker-address-wrapper {
    label {
      &:nth-last-of-type(1) {
        display: none;
      }
    }
  }
}
.base-search {
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /deep/.el-input--suffix {
    width: 100%;
    margin: 0 15px;
  }
  .el-input {
    // width: 400px;
    margin: 0 15px;
  }
  .date-picker {
    margin: 0 15px;
    .el-range-separator {
      width: auto;
    }
  }
}
</style>
